<template>
    <div class="d-flex align-items-center">
        <nav-icon
            v-if="useVerticalNav && pageName"
            class="me-3"
            v-bind:page-name="pageName"
            style="width: 3rem; height: 3rem"
            primary />
        <div
            v-if="!useVerticalNav && iconClass"
            class="page-header-img"
            v-bind:class="iconClass" />
        <h1 class="m-0">
            {{ internalHeader }}
        </h1>
        <div
            v-if="showHelp"
            class="align-self-start mt-2 ms-2">
            <pc-help-icon v-on:click="$emit('help-clicked', $event)" />
        </div>
    </div>
</template>

<script>
    import navIcon from "Components/page/Navigation/navIcon.vue";
    import { LOC_PAGE_NAME_SYMBOL } from "_Main/injectionSymbols";

    export default {
        components: { navIcon },
        inject: { LocalizedPageName: LOC_PAGE_NAME_SYMBOL },
        props: {
            header: { type: String, required: false, default: null },
            // iconClass is used for the old icons
            iconClass: { type: String, required: false, default: null },
            // pageName is used by the new vertical nav to find the icon
            pageName: { type: String, required: false, default: null },
            showHelp: { type: Boolean, required: false, default: false }
        },
        emits: ["help-clicked"],
        data() {
            return {
                useVerticalNav: Boolean(window.pc_use_vertical_nav)
            };
        },
        computed: {
            internalHeader() {
                if (this.header) {
                    return this.header;
                }
                return this.LocalizedPageName;
            }
        }
    };
</script>
